import { defineComponent as _defineComponent } from 'vue'
import { YMPush } from '@/uitls/uitls';
import { onMounted, ref, onUnmounted } from "vue"
import MatchTabs from "@/components/match/MatchTabs.vue"
import Platform from '@/config/platform';
import EventBus from '@/uitls/EventBus';
import { storeToRefs } from "pinia"
import router from "@/router";
import { cheackQuery, nativeToNewWeb, toLocationBrowser, toDownloadApp } from "@/uitls/native";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'Match',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const ConfigpiniaStore = serverConfigPiniaState();
const { matchAD, is_has_history } = storeToRefs(ConfigpiniaStore);
const { getConfig } = ConfigpiniaStore;
const route = useRoute();
// const pos2 = require(`@/assets/${process.env.VUE_APP_NAME}/home_post_2.png`)
// const pos1 = require(`@/assets/${process.env.VUE_APP_NAME}/home_post_1.png`)
const showAd = ref(true)
const th = process.env.VUE_APP_Language as string;
// const screen = window.screen;

const offArterBtn = require("@/assets/images/guanbi.png");
const arterBg = require(`@/assets/${process.env.VUE_APP_NAME}/download.png`)
const arterBtn = require(`@/assets/${process.env.VUE_APP_NAME}/download_btn.png`)
const downLogo = require(`@/assets/${process.env.VUE_APP_NAME}/aboutLogo.png`);
const close_icon = require(`@/assets/images/guanbi_icon.png`)
const standalone = Platform.standalone;

const showDownApp = ref(false);
const alertDown = ref(false);

onMounted(() => {
  YMPush('MAIN', 'MatchPage');
  cheackQuery(route);
  // getData()

  // document.onscroll = function () {
  //   clearTimeout(timer);
  //   timer = setTimeout(isScrollEnd, 1000);
  //   showAnimation.value = false;
  //   scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

  // }
  if (Platform.client != 'h5') {
    getConfig()
  } else {
    showDownApp.value = !standalone;
  }
  if (th == 'th') {
    showAd.value = false
  }
})
//福利图标的透明度
// const showAnimation = ref(true)
// const isScrollEnd = () => {
//   scrollEndTop = document.documentElement.scrollTop || document.body.scrollTop;
//   if (scrollTop === scrollEndTop) {
//     showAnimation.value = true
//   }
// }
// let scrollTop = 0;
// let scrollEndTop = 0;
// let timer = null;
onUnmounted(() => {
  EventBus.off('refreshMatchData')
  EventBus.off('refreshSuccess')
  EventBus.off('matchAlertDownShow')
})

let tabIdx = t('home.tabIdx')
let state = ref(tabIdx);

const tabchange = (idx) => {
  //   tab改变时
  // EventBus.emit("changeIndex");
  console.log(idx);
  if (idx == 0 && !standalone && Platform.client == 'h5') {
    alertDown.value = true;
    return false;
  }

  return true;
};

const matchSettingClick = () => {
  if (!standalone && Platform.client == 'h5') {
    alertDown.value = true;
  } else {
    nativeToNewWeb(router, '/matchsetting');
  }
}
const isRefesh = ref(false)
// const refreshData = () => {
//   isRefesh.value = true;
//   EventBus.emit("refreshMatchData");
// }

EventBus.on("refreshSuccess", () => {
  //刷新成功
  isRefesh.value = false;
})

EventBus.on('matchAlertDownShow', () => {
  alertDown.value = true;
})

const open = () => {
  if (Platform.downUrl != "") {
    YMPush("DOWNLOAD", "点击下载")
    toDownloadApp();
  }
};

// VUE_APP_PRIMARY_COLOR
const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const activeColor = process.env.VUE_APP_DOWNLOAD_COLOR as string;
const activeFontColor = process.env.VUE_APP_DOWNLOAD_FONT_COLOR as string;
// console.log(primaryColor);


const __returned__ = { t, ConfigpiniaStore, matchAD, is_has_history, getConfig, route, showAd, th, offArterBtn, arterBg, arterBtn, downLogo, close_icon, standalone, showDownApp, alertDown, tabIdx, state, tabchange, matchSettingClick, isRefesh, open, primaryColor, activeColor, activeFontColor, MatchTabs, Platform, toLocationBrowser, toDownloadApp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})